import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { environment } from 'environments/environment';

const breadcrumb: any[] = [
  {
    title: 'Home'
  
  },
  {
    title: 'Finished Good stock status report'
 
  }
];

@Component({
  selector: 'page-fg-stock-in-out-status-report',
  templateUrl: './fg-stock-in-out-status-report.html',
  styleUrls: ['./style-report.scss']
})

export class PageFgStockInOutStatusReport implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  stateCtrl: FormControl;
  filteredStates: any;
  platting:string;material:string;wip:string;supplier:string;ng:string;clam:string;fg:string;sale:string;cancel:string;
  
  private chart: any;

  rows:String;
  temp = [];
  rowspan="2";
  ckPlating:any;
  ckOutstock:any;
  items:any;
  print="";
  iFramUrl:any;
  selected = [];
  ckSale:any;
  material_total:any;
  models = [];
  supplierName:string;
  dateTime:any;
  ckPacking:any;
  ckShop:any;
  ckInstock:any;
  ckRemain:any;
  ckSaleCancel:any;
  key:any;
  fileSelectExport:string;
  fileSelectPrint:string;
  public date_selected:any;
  fetchSupplier=[];
  loadingIndicator: boolean = true;

    //diaglog
    dialogRef: MdDialogRef<ReportFGListDialog>;
    selectedOption: string;

  constructor(private sanitizer: DomSanitizer,private AmCharts: AmChartsService,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
   this.material_total=0;
   this.dateTime=Date.now();
   let date = new Date();
   this.date_selected = date.toISOString().split('T')[0];
    this.fetchModel((model) => {
      this.models = model.map(function (val) {
        return [val.tp_part_no]
      });
      console.log('------this.model------', this.models);
    });

    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
    .startWith(null)
    .map(name => this.filterStates(name));
   // console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);

  }//end constrocture

  changStatusPacking(){
    this.ckRemain=false;
    this.ckOutstock=false;
    this.ckSale=false;
    this.ckInstock=false;
    this.ckSaleCancel=false;
    this.fileSelectExport="fg_received_list_export.php";
    this.fileSelectPrint="fg_received_list_print.php";
  }

  changStatusRemain(){
    this.ckPacking=false;
    this.ckOutstock=false;
    this.ckSale=false;
    this.ckInstock=false;
    this.ckSaleCancel=false;
    this.fileSelectExport="stock-location-fg-export.php";
    this.fileSelectPrint="stock-location-fg-print.php";
  }
  changStatusCollect(){
    this.ckRemain=false;
      this.ckPacking=false;
      this.ckSale=false;
      this.ckInstock=false;
      this.ckSaleCancel=false;
      this.fileSelectExport="fg_outstock_list_export.php";
      this.fileSelectPrint="fg_outstock_list_print.php";
  }
  changStatusSale(){
    this.ckRemain=false;
    this.ckPacking=false;
      this.ckOutstock=false;
      this.ckInstock=false;
      this.ckSaleCancel=false;
      this.fileSelectExport="fg_sale_list_export.php";
      this.fileSelectPrint="fg_sale_list_print.php";
  }
  changStatusSaleCancel(){
    this.ckRemain=false;
    this.ckPacking=false;
    this.ckOutstock=false;
    this.ckSale=false;
    this.ckInstock=false;
    this.fileSelectExport="fg_sale_cancel_list_export.php";
    this.fileSelectPrint="fg_sale_cancel_list_print.php";
    
  }
  changStatusInstock(){
    this.ckRemain=false;
    this.ckPacking=false;
    this.ckOutstock=false;
    this.ckSale=false;
    this.ckSaleCancel=false;
    this.fileSelectExport="fg_instock_list_export.php";
    this.fileSelectPrint="fg_instock_list_print.php";
  }
openExport(){
  if(this.ckRemain==true){
    this.iFramUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/report/"+this.fileSelectExport+"?key="+this.key+"&date_selected="+this.date_selected);
  }else{
    this.iFramUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/report/"+this.fileSelectExport+"?key="+this.key+"&date_selected="+this.date_selected);
  }
  }
 openPrint(printSectionId:string){
   let popupWinindow
   if(this.ckRemain==true){
    popupWinindow = window.open(environment.url+'/report/'+this.fileSelectPrint+'?key='+this.key+'&date_selected='+this.date_selected, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
   }else{
    popupWinindow = window.open(environment.url+'/report/'+this.fileSelectPrint+'?key='+this.key+'&date_selected='+this.date_selected, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
   }
 }
  
    //check box
    openDialog(message:string) {
      let dialogRef = this.dialog.open(ReportFGListDialog,{disableClose:true});
      let instance = dialogRef.componentInstance;
      instance.Message=message;
    }
    closeDialog() {
      this.dialog.closeAll();
    }
    handleLoad(e){
        //alert(e.target.focus());
        //e.target.focus();
       this.closeDialog();
    }

  
    fetchModel(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', environment.url+'/api/getJSON_product_model.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  //check box


search(){
  this.openDialog('loading..');
  console.log('------val------',this.key,this.ckPlating);
 

  if(this.key!=null && this.key!="" && this.key!=undefined){

      if(this.ckRemain==true){
        this.iFramUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/report/"+this.fileSelectPrint+"?key="+this.key+"&date_selected="+this.date_selected);
      }else{
        this.iFramUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/report/"+this.fileSelectPrint+"?key="+this.key+"&date_selected="+this.date_selected);
      }
        


  }else{
    if(this.ckRemain==true){
    this.iFramUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/report/"+this.fileSelectPrint+"?key=null&date_selected="+this.date_selected);
    console.log('------val------1',this.key,this.iFramUrl);
    }else{
      this.iFramUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.url+"/report/"+this.fileSelectPrint+"?key=null&date_selected="+this.date_selected);
    }
  }
}

  filterStates(val: string) {
   
    this.key=val;
 console.log('------val------',this.key);

    return val ? this.models.filter((s) => new RegExp(val, 'gi').test(s)) : this.models;
  }

  ngOnInit() {

  }


}
//dialog
@Component({
  selector: 'report-dialog',
  templateUrl: 'report-dialog.html',
})
export class ReportFGListDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<ReportFGListDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/report/fg-stock-in-out-status-report.ts